import { ITreatyParts } from './ITreatyParts.js'

export interface ITreaty {
  congress: number
  endCongressId: number
  parts: ITreatyParts
  resolutionText: string
  transmittedDate: string
  treatyNum: number
  treatySubject: string
  treatySuffix: string
  updateDate: string
  url: string
}
